import '@shopify/polaris/build/esm/styles.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { separate_route as SeparateRoute, public_route, private_route } from './config/router-define';
import AppFrame from 'layout/appFrame';
import Theme404 from 'layout/404';
import ProtectedRoute from 'ProtectedRoute';
import { useCallback } from 'react';
import { FloatingBannerProvider } from 'context/FloatingBannerProvider';
import BottomBar from 'components/buttomBar';
import BottomBarMovingTicket from 'components/bottomBarForMovingTicket';
import { AuthProvider } from 'context/AuthContext';
import { CurrentTicketMovingProvider } from 'context/CurrentTicketMovingContext';
import { DeleteConfirmProvider } from 'context/DeleteConfirmContext';
import { SettingsProvider } from 'context/SettingsContext';
import { SocketProvider } from 'context/SocketContext';
import { UserRoleProvider } from 'context/UserRoleContext';
import { HelmetProvider } from 'react-helmet-async';
import LockScreen from 'components/LockScreen';

// const baseHref = document.querySelector('base')?.getAttribute('href')?.replace(/\/$/, '');
//     <BrowserRouter basename={baseHref}>

export function App() {
  const delayloadingScreen = useCallback(async () => {
    document.getElementById('root').style.display = 'block';
    document.getElementById('before_load').style.display = 'none';
    document.getElementById('before_load').style.width = '0';
    document.getElementById('before_load').style.height = '0';
  }, []);

  delayloadingScreen();

  return (
    <BrowserRouter>
      <SettingsProvider>
        <LockScreen />
        <DeleteConfirmProvider>
          <HelmetProvider>
            <Routes>
              {SeparateRoute.map((MainRouter, index) => (
                <Route key={index} path={MainRouter.path} element={<MainRouter.Entity />} />
              ))}
              {public_route.map((MainRouter, index) => (
                <Route key={`public_${index}`} path={MainRouter.path} element={<MainRouter.Entity />} />
              ))}
              {private_route.map((MainRouter, index) => (
                <Route
                  key={`private_${index}`}
                  path={MainRouter.path}
                  element={
                    <AuthProvider>
                      <ProtectedRoute>
                        <CurrentTicketMovingProvider>
                          <FloatingBannerProvider>
                            <UserRoleProvider>
                              <SocketProvider>
                                <AppFrame>
                                  <MainRouter.Entity />
                                </AppFrame>
                              </SocketProvider>
                            </UserRoleProvider>
                          </FloatingBannerProvider>
                          <BottomBar />
                          <BottomBarMovingTicket />
                        </CurrentTicketMovingProvider>
                      </ProtectedRoute>
                    </AuthProvider>
                  }
                />
              ))}
              <Route key={99999} path="*" element={<Theme404 />} />
            </Routes>
          </HelmetProvider>
        </DeleteConfirmProvider>
      </SettingsProvider>
    </BrowserRouter>
  );
}

export default App;
